import React from "react";

const Login = () => {
  return <h2>This is Login</h2>;
};

export default Login;
